export const handleSeasonCard = (params: { element: HTMLDivElement; sizes: { size1x: number; size2x: number } }) => {
  const { element, sizes } = params;
  const nextItem = element?.nextElementSibling as HTMLElement;
  const nextItemImages = nextItem?.querySelectorAll('[data-src]') as NodeListOf<HTMLImageElement>;

  nextItemImages?.forEach((image) => {
    if (image instanceof HTMLImageElement) {
      image.setAttribute('src', `${image.dataset.src}?im=Resize,width=${sizes.size1x}` || '');
      image.setAttribute(
        'srcset',
        `${image.dataset.src}?im=Resize,width=${sizes.size1x} 1x, ${image.dataset.src}?im=Resize,width=${sizes.size2x} 2x` ||
          ''
      );
    }
  });
};
